export const initModal = (evt) => {
    const target = (!!evt.target.dataset.handle || !!evt.target.dataset.target) ? evt.target : evt.target.parentElement;
    document.querySelectorAll('.stack-target__wrapper').forEach((el)=>el.classList.remove('stack-target--active'));
    if(!isMobile()){
        target.classList.add('stack-target--active');
    }
    const modal = document.getElementById('lb-stack-modal');
    const sidebar = document.getElementById('lb-stack-product');
    modal.style.opacity = '0';
    sidebar.style.opacity = '0';
};

export const isMobile = () => {
    return window.innerWidth < 990;
}

export const checkWidth = () => {
    if(window.innerWidth < 990){
        document.getElementById('lb-stack-product').classList.add('hidden');
        document.getElementById('lb-stack-modal').classList.remove('hidden');
    }else{
        document.getElementById('lb-stack-close').click();
        document.getElementById('lb-stack-product').classList.remove('hidden');
    }
};

export const closeModal = (evt) => {
    evt.preventDefault();
    const modal = document.getElementById('lb-stack-modal');
    modal.style.top = '100%';
    modal.style.opacity = '0';
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

export const setModalPosition = () => {
    const modal = document.getElementById('lb-stack-modal');
    const sidebar = document.getElementById('lb-stack-product');

    if(isMobile()) {
        const top = window.scrollY;
        modal.style.opacity = '1';
        modal.style.top = '0px';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${top}px`;
        document.body.style.width = `100%`;
    }else{
        sidebar.style.opacity = '1';
    }

};
export const watchStack = (fn) => {
    window.onresize = checkWidth;
    checkWidth();
    if(isMobile()){
        document.querySelectorAll('.stack-target').forEach((el)=>el.classList.remove('stack-target--active'));
    }
    document.querySelectorAll('.stack-target__wrapper').forEach((el) => {
        el.addEventListener('click', fn);
    });
    document.getElementById('lb-stack-close').addEventListener('click', closeModal);
    document.getElementById('lb-stack-modal').addEventListener('click', (evt)=>{
        if(evt.target.id==='lb-stack-modal'){
            closeModal(evt);
        }
    });
};